import React from 'react'
import { Link } from 'react-router-dom'

const Section5 = ({datas}) => {
  return (
    <div className='s3-fin-reco f-width m-auto'>
        <div className='row bg-dark rounded-4 fin-s3-cta-btn shadow'>
            <div className='col-lg-7 col-sm-12 text-white'>
                <p className='fs-md'>{datas.heading}</p>
                <p>{datas.subText}</p>
            </div>
            <div className='col-lg-5 col-md-12 text-end align-self-center'>
                <Link to={datas.btnLink}><div className='btn btn-light rounded-pill'>Book Demo Call</div></Link>
            </div>
        </div>
    </div>
  )
}

export default Section5